import * as React from "react";
import { Text, View, useSx } from "dripsy";
import AnimatedPressable from "./animated-pressable";
import { BottomTabLink } from "react-native-ridge-navigation";
import type { BottomTabType } from "react-native-ridge-navigation";
import { roundness } from "@provider/dripsy";

function HeaderItem<T extends BottomTabType>({
  to,
  title,
  highlighted,
  badge,
}: {
  to: T;
  title: string;
  highlighted?: boolean;
  badge?: number;
}) {
  return (
    <BottomTabLink to={to} params={{}}>
      {({ isSelected, ...rest }) => (
        <Inner highlighted={highlighted} isSelected={isSelected} title={title} badge={badge} {...rest} />
      )}
    </BottomTabLink>
  );
}

const Inner = ({ isSelected, title, highlighted, badge, ...rest }: any) => {
  const sx = useSx();
  return (
    <AnimatedPressable
      {...(rest as any)}
      style={sx({
        borderRadius: roundness,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: highlighted
          ? isSelected
            ? "$primaryPressed"
            : "$primary"
          : isSelected
          ? "$secondaryBackgroundDarker"
          : "$secondaryBackground",
      })}
      animate={React.useMemo(
        () =>
          ({ hovered, pressed }) => {
            return sx({
              backgroundColor: highlighted
                ? hovered || pressed
                  ? "$primaryPressed"
                  : "$primary"
                : hovered || pressed || isSelected
                ? "$secondaryBackgroundDarker"
                : "$secondaryBackground",
            });
          },
        [isSelected, highlighted]
      )}
    >
      <Text
        sx={{
          fontSize: [14, 15, 16],
          fontWeight: "500",
          color: highlighted ? "#ffffff" : isSelected ? "$primary" : "$onSecondaryLight",
          paddingHorizontal: "$2",
          paddingVertical: "$1",
        }}
      >
        {title}
      </Text>
      {badge ? (
        <View
          sx={{
            position: "absolute",
            top: -7,
            right: -7,
            minWidth: 18,
            height: 18,
            paddingHorizontal: 4,
            borderRadius: 360,
            backgroundColor: "$primary",
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: "$secondaryBackground",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text sx={{ color: "$background", fontSize: 10, fontWeight: "bold", lineHeight: 12 }}>
            {badge > 9 ? "9+" : badge}
          </Text>
        </View>
      ) : null}
    </AnimatedPressable>
  );
};
export default HeaderItem;
